import * as React from "react"
import colors from "theme/colors"

const SvgComponent = ({
  color = colors.black,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 24
  const h = 24
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="1" y="1" width="22" height="22" rx="2" fill="white" />
        <rect
          x="1"
          y="1"
          width="22"
          height="22"
          rx="2"
          stroke={color}
          strokeWidth="2"
        />
      </svg>
    </svg>
  )
}

export default SvgComponent
